import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

const OficinaFormGroup = ({ iError, iTouched, fIsSubmitting, disabled }) => {
  const __zariContext = React.useContext(ZariContext)
  const [areas, setAreas] = React.useState([])

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.OFICINA)
      .then(({ data }) => setAreas(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='OFICINA(S) SOLICITANTE' htmlFor='select-oficinasolicitante' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idOficinaSolicitante'>
          {({ field, form }) => (
            <select
              multiple
              className={`form-control ${iTouched && iError ? 'is-invalid' : ''}`}
              disabled={fIsSubmitting || disabled}
              id='select-oficinasolicitante'
              value={Array.isArray(field.value) ? field.value : field.value ? [field.value] : []}
              onChange={e => {
                const selected = Array.from(e.target.selectedOptions, option => option.value)
                form.setFieldValue('_idOficinaSolicitante', selected)
              }}
              style={{ minHeight: '68px' }}
            >
              {areas.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(OficinaFormGroup)
